<template>
    <div class="var-editor-wrapper">
        <table class="simple-tbl">
            <thead class="head">
            <tr class="row">
                <th class="indicator">&nbsp;</th>
                <th class="name">名称</th>
                <th class="type">类型</th>
                <th class="value">数值</th>
                <th class="desc">描述</th>
                <th v-if="editable && !fixedList" class="btns-col">
                    <i class="el-icon-plus" style="margin-left: 9px; cursor: pointer;" @click="addItem()"></i>
                </th>
            </tr>
            </thead>
            <draggable v-if="editable && !fixedList" tag="tbody" class="body" handle=".draggle-handle" v-model="varItems" @start="draggingItems=true" @end="draggingItems=false">
                <tr class="row" v-for="(item, indx) in varItems" @dblclick="hanldeItemDblClick(indx)">
                    <td class="indicator draggle-handle" title="按下、拖动 可调整行的位置">
                        {{ indx + 1 }}
                    </td>
                    <td class="editable name">
                        <input class="input" type="text" v-model="item.name"/>
                    </td>
                    <td class="editable type">
                        <span style="display: inline-block; padding: 6px;" v-if="hasFixedType()">{{ item.type }}</span>
                        <el-select v-else v-model="item.type">
                            <el-option v-for="javaType in getJavaTypes()" :label="javaType" :value="javaType"></el-option>
                        </el-select>
                    </td>
                    <td class="editable value">
                        <input v-if="item.type == 'String'" class="input" type="text" v-model="item.value"/>
                        <input v-else class="input" type="text" placeholder="null" @change="filterItemValue(indx)" v-model="item.value"/>
                    </td>
                    <td class="editable desc">
                        <input class="input" type="text" v-model="item.desc"/>
                    </td>
                    <td class="btns-col">
                        <i class="el-icon-close" style="cursor: pointer;" @click="delItem(indx)"></i>
                    </td>
                </tr>
            </draggable>
            <tbody v-else="" class="body">
            <tr class="row" v-for="(item, indx) in varItems" @dblclick="hanldeItemDblClick(indx)" :class="{'selected' : isItemSelected(item)}">
                <td class="indicator">
                    {{ indx + 1 }}
                </td>
                <td class="name">
                    {{ item.name }}
                </td>
                <td class="type">
                    {{ item.type }}
                </td>
                <td :class="{ 'editable' : editable}" class="value">
                    <input v-if="editable" class="input" type="text" v-model="item.value"/>
                    <span v-else="">{{ item.value }}</span>
                </td>
                <td class="desc">
                    {{ item.desc }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { Utils, Jqext } from '../../app.base'
    import { Vue, getSimpleJavaTypes, convertToTypedStr } from '../../app.vues'

    let Toast = Jqext.Toast;

    const javaTypeNames = getSimpleJavaTypes();

    export default {
        name: 'swb-var-list-editor',
        desc: '简单变量列表编辑器',
        props: {
            varList: {//{ name, type, value, desc, seqNo}
                default: function () {
                    return [];
                }
            },
            editable: {
                type: Boolean,
                default: true
            },
            //是否固定类型（编辑模式下有效）
            fixedType: {
                type: String,
                default: null
            },
            //是否固定变量列表
            fixedList: {
                type: Boolean,
                default: false
            },
            selectable: {
                type: Boolean,
                default: false
            },
            //初始提示消息
            initHint: {
                type: String
            },
            dblClickHandler: {
                type: Function
            }
        },

        data() {
            return {
                draggingItems: false,
                //
                varItems: [],
                //
                selected: null
            }
        },

        watch: {
            varList(newVal, oldVal) {
                this.initData();
            }
        },

        mounted() {
            this.initData();
            //
            if(this.initHint) {
                Toast.show(this.initHint, 3000, 'info');
            }
        },
        beforeDestroy() {
            //props
            this.varList = null;
            this.dblClickHandler = null;
            //data
            this.varItems = null;
        },

        methods: {
            hasFixedType() {
                return typeof this.fixedType == 'string' && this.fixedType;
            },
            getJavaTypes() {
                return javaTypeNames.clone();
            },
            initData() {
                let varList = Utils.merge([], this.varList);
                //补充检查seqNo
                let i = 0;
                varList.forEach(function (item) {
                    i++;
                    if(item.seqNo == null) {
                        item.seqNo = i;
                    }
                });
                varList = varList.sort(function (item1, item2) {
                    return item1.seqNo - item2.seqNo;
                });
                //
                this.varItems = varList;
            },
            getSelected() {
                return this.selected;
            },
            isItemSelected(item) {
                return item == this.selected;
            },
            hanldeItemDblClick(index) {
                if(this.selectable) {
                    this.selected = this.varItems[index];
                    //
                    if(this.dblClickHandler) {
                        this.dblClickHandler.call(this.$parent, this.selected);
                    }
                }
            },
            delItem(index) {
                let varItems = this.varItems;
                //
                let delItem = varItems[index];
                if(this.selected == delItem) {
                    this.selected = null;
                }
                //
                varItems.removeAt(index);
                this.varItems = varItems.clone();
            },
            addItem() {
                let varItems = this.varItems;
                varItems.push({
                    name: '',
                    type: this.hasFixedType() ? this.fixedType : 'String',
                    value: null,
                    desc: ''
                });
                this.varItems = varItems.clone();
            },
            filterItemValue(index) {
                let varItems = this.varItems;
                //
                let theItem = varItems[index];
                theItem.value = convertToTypedStr(theItem.value, theItem.type);
                // console.log(theItem.value);
                this.$set(this.varItems, index, theItem);
            },
            //校验是否通过
            validate() {
                let varItems = Utils.merge([], this.varItems);
                let mapSeqNoMap = {};
                for(let i = 0, c = varItems.length; i < c; i++) {
                    let tmpItem = varItems[i];
                    let rowNo = i + 1;
                    if(Utils.isNoB(tmpItem.name)) {
                        Toast.show('第 ' + rowNo + ' 行 的名称 为空');
                        return false;
                    }
                    let name = tmpItem.name.trim();
                    let rowNoPrev = mapSeqNoMap[name];
                    if(rowNoPrev != null) {
                        Toast.show('第 ' + rowNo + ' 行 与 第 ' + rowNoPrev + ' 行 的名称 重复');
                        return false;
                    }
                    mapSeqNoMap[name] = rowNo;
                    //
                    if(Utils.isNoB(tmpItem.type)) {
                        Toast.show('第 ' + rowNo + ' 行 的类型 未设置');
                        return false;
                    }
                }
                //
                return true;
            },
            getData() {
                let varItems = Utils.merge([], this.varItems);
                if(this.editable) {
                    for(let i = 0, c = varItems.length; i < c; i++) {
                        let tmpItem = varItems[i];
                        tmpItem.seqNo = i + 1;
                    }
                }
                return varItems;
            }
        }
    }

</script>

<style>
    .var-editor-wrapper .simple-tbl {
        width: 100%;
    }

    .var-editor-wrapper .simple-tbl .indicator, .var-editor-wrapper .simple-tbl .btns-col {
        text-align: center;
        width: 50px;
    }

    .var-editor-wrapper .simple-tbl .name {
        width: 200px;
    }

    .var-editor-wrapper .simple-tbl .type {
        width: 100px;
    }

    .var-editor-wrapper .simple-tbl .value {
        width: 120px;
    }

    .var-editor-wrapper .simple-tbl .body .editable {
        padding: 0;
    }

    .var-editor-wrapper .simple-tbl .body .row.selected {
        background-color: #FFEFE5;
    }

    .var-editor-wrapper .simple-tbl .body .input {
        width: 100%;
        height: 100%;
        border: none;
        padding: 5px;
    }

    .var-editor-wrapper .simple-tbl .body .value .input {
        color: navy;
    }

    .var-editor-wrapper .simple-tbl .body .desc .input {
        color: gray;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/VarListEditor.vue